module.exports = __webpack_public_path__ + "static/media/logout-red.0502fa78.png";